import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
function validateSelect(label, value, options) {
  var lowercaseLabel = label.toLowerCase();
  if (value === '' || value === null) {
    return "Please select a ".concat(lowercaseLabel, ".");
  }

  // Supports dynamic options, which can cause the
  // previously-selected value to become invalid
  if (!options.some(function (option) {
    return option.value.toString() === value.toString();
  })) {
    return "Please select a ".concat(lowercaseLabel, ".");
  }
  return '';
}
export default validateSelect;